import styled from 'styled-components';

export const Wrapper = styled.p`
  ${props => props.theme.typography[props.variant]};
`;